import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useAuthStore } from '@/store/authStore';
import { validatePhoneNumber } from '@/utils/validation';

interface LoginFormData {
  phoneNumber: string;
  password: string;
}

export function LoginForm() {
  const { login, isLoading, error } = useAuthStore();
  const navigate = useNavigate();
  
  const { register, handleSubmit, formState: { errors } } = useForm<LoginFormData>();

  const onSubmit = async (data: LoginFormData) => {
    try {
      const success = await login(data.phoneNumber, data.password);
      if (success) {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
      <div className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="phoneNumber">رقم الجوال</Label>
          <Input
            id="phoneNumber"
            type="tel"
            dir="ltr"
            className="text-left"
            {...register('phoneNumber', {
              required: 'رقم الجوال مطلوب',
              validate: validatePhoneNumber
            })}
            placeholder="009665xxxxxxxx, 009659xxxxxxx"
          />
          {errors.phoneNumber && (
            <p className="text-sm text-red-500">{errors.phoneNumber.message}</p>
          )}
        </div>

        <div className="space-y-2">
          <Label htmlFor="password">كلمة المرور</Label>
          <Input
            id="password"
            type="password"
            {...register('password', {
              required: 'كلمة المرور مطلوبة',
              minLength: { value: 4, message: 'يجب أن تتكون كلمة المرور من 4 أرقام على الأقل' },
              maxLength: { value: 15, message: 'يجب أن تتكون كلمة المرور من 4 أرقام على الأقل' },
              pattern: { value: /[a-zA-Z0-9]$/, message: 'يجب أن تتكون كلمة المرور من 4 أرقام على الأقل' }
            })}
            placeholder="********"
            maxLength={15}
          />
          {errors.password && (
            <p className="text-sm text-red-500">{errors.password.message}</p>
          )}
        </div>

        <Button type="submit" className="w-full" disabled={isLoading}>
          {isLoading ? 'جاري تسجيل الدخول...' : 'دخول'}
        </Button>
      </div>

      {error && (
        <p className="text-sm text-red-500 text-center">{error}</p>
      )}
    </form>
  );
}